<template>
	<div class="el-col-sm-24 flex flex_between">
		<el-tooltip placement="bottom" :open-delay="500" :disabled="!tooltip">
			<span slot="content" v-html="tooltip"></span>
			<md-switch style="margin: 5px"
				:disabled="!canBuyTci"
				v-model="useInsurance"
				@change="onChange">
			</md-switch>
		</el-tooltip>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				useInsurance: false
			};
		},
		methods: {
			onChange() {
				this.params.api.forEachNode(rowNode => {
					if(!rowNode.data.isInsuranceDisabled) {
						rowNode.data[this.params.column.colDef.field] = this.useInsurance;
					}
				});
			},
		},
		computed: {
			canBuyTci() {
				return this.params.canBuyTci;
			},
			tooltip() {
				return this.useInsurance
					? this.$t("investor.exchange.table.operation.bid.tciSwitch.all.on.tooltip")
					: (!this.canBuyTci
						? this.$t("investor.exchange.table.operation.bid.tciSwitch.all.off.notAllowedToBuy.tooltip")
						: this.$t("investor.exchange.table.operation.bid.tciSwitch.all.off.tooltip")
					);
			},
		},
		watch: {
			canBuyTci: {
				handler() {
					this.useInsurance = this.canBuyTci;
				},
				immediate: true
			}
		}
	};
</script>
